import { Action } from 'typescript-fsa';

export const getArrayAfterAsyncCall = <T>(state: T[], action: Action<{ result: T[] }>): T[] => {
  return action.payload.result;
};

export const getArrayAfterAsyncCreateCall = <T>(state: T[], action: Action<{ result: T }>): T[] => {
  return [...state, action.payload.result];
};

export const deleteArrayItemAfterAsyncCall = <T extends { id: string | number }>(
  state: T[],
  action: Action<{ params: string | number }>,
): T[] => {
  return state.filter(({ id }) => id !== action.payload.params);
};

export const updateArrayItemAfterAsyncCall = <T extends { id: string | number }>(
  state: T[],
  action: Action<{ result: T }>,
): T[] => {
  return state.map((entity) =>
    entity.id === action.payload.result.id ? { ...entity, ...action.payload.result } : entity,
  );
};
